<template>
  <div
    class="page-wrap"
    :class="{
      'page-wrap__electron': isElectron,
      'page-wrap__web__share': !isElectron && isScreenShare,
      'page-wrap__electron__share': isElectron && isScreenShare,
      'page-wrap__share__remote': isScreenShareRemote,
      'page-wrap__record': isRecordPage,
      'page-wrap__cdn': isStudentDownstageCDN,
    }"
  >
    <live-header
      v-show="showHeader"
      :liveSDK="liveSDK"
      :isReady="isReady"
      :lessonId="lessonId"
      @showSetting="handleShowSetting"
      :isWin="isWin"
    />
    <div class="column live-page-cont-wrap">
      <div class="column-left" :class="{ 'column-left--full': !showEmbedChat }">
        <div class="resize-bar"></div>
        <div class="resize-line"></div>
        <!-- 左侧直播内容区域 -->
        <div
          class="left-live-cont-wrap resize-save"
          :class="{ 'resize-save__record': isRecordPage }"
        >
          <div
            class="layout-box"
            ref="layoutBoxRef"
            :class="{
              'layout-box__horizontal':
                layout === 'horizontal' && !isStudentDownstageCDN,
              'layout-box__vertical':
                layout === 'vertical' && !isStudentDownstageCDN,
              'layout-box__speaker':
                layout === 'speaker' && !isStudentDownstageCDN,
              'layout-box__share':
                isElectron && isScreenShare && !isStudentDownstageCDN,
              'layout-box__cdn': isStudentDownstageCDN,
            }"
          >
            <person-list
              v-if="!isScreenShare || !isElectron"
              class="person-list-box"
              ref="personListRef"
              :isReady="isReady"
            />
            <div class="white-board-wrap" ref="whiteBoardWrap">
              <!-- 网页端本地共享或者两端接收共享时 -->
              <ScreenShare
                ref="screenShareRef"
                class="screen-share-box"
                v-show="showScreenShare"
                :playUrl="roomInfo.play_url"
                @update:showPlayButton="handleUpdateShowPlayButton"
              ></ScreenShare>
              <WhiteBoard
                v-show="
                  !(
                    !isShowScreenShareWhiteboard &&
                    isScreenShare &&
                    isElectron
                  ) && !isStudentDownstageCDN
                "
                class="white-board-box"
                :class="{
                  white_board_box_screen_remote:
                    isShowScreenShareWhiteboardRemote,
                }"
                ref="whiteBoardBox"
                :liveSDK="liveSDK"
                :isImReady="isReady"
                :lessonId="lessonId"
                :isWhiteBoard="isWhiteBoard"
                :controlPage="!isStudent"
                :isRecordPage="isRecordPage"
                @data-synced="sendMessageUseIm"
                @video-volume-changed="handleCoursewareVideoVolumeChanged"
                @on-error="handleWhiteBoardError"
              />
              <!-- 屏幕共享播放按钮 -->
              <div
                v-if="screenShareShowPlayButton"
                class="screen-share-play-button-overlay"
                @click="handleScreenSharePlayClick"
              >
                <div class="screen-share-play-button">
                  <div class="icon-bars">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                  </div>
                  <div class="screen-share-play-button-text">
                    点击进入直播间
                  </div>
                </div>
              </div>
              <courseware-list
                v-if="whiteboardType === 'courseware' && !isStudent"
                class="courseware-list"
              />
              <watermark
                v-if="
                  !isRecordPage && !isLoading && !(isScreenShare && isElectron)
                "
              />
            </div>
          </div>
          <bottom v-show="showBottom" />
        </div>
      </div>
      <!-- 右侧聊天区域 -->
      <div v-show="showEmbedChat" class="resize-right-chat-wrap column-right">
        <div class="resize"></div>
        <div class="bar-btn"></div>
        <div class="right-content">
          <slot name="chat"></slot>
        </div>
      </div>
    </div>

    <device-check
      v-if="showDeviceCheck.visible && !isStudent"
      class="device-check"
      :lessonId="lessonId"
      :type="showDeviceCheck.type"
      @enterRoom="onEnterRoom"
    />
    <div class="loading-box" v-if="isLoading">
      <div class="mask"></div>
      <div class="loading">加载中...</div>
    </div>

    <!-- 可拖动设置窗口 -->
    <drag-wrap
      v-if="settingVisible"
      :visible="settingVisible"
      modalId="live-set"
      modalName="直播设置"
    >
      <live-set @close="handleShowSetting" :initActive="initSetActive" />
    </drag-wrap>
    <!-- 禁止进入直播间弹窗 -->
    <disabled-enter
      ref="disabledEnterDialog"
      v-if="!isRecordPage"
    ></disabled-enter>
    <div class="disabled-capture-mask" v-if="isShowDisabledCapture">
      <div class="tips" v-if="isShowDisabledCaptureTips">
        录屏软件仍未关闭，请仔细核查
      </div>
      <p>本课程已开启防录屏</p>
      <p>关闭录屏软件后，即可正常看课</p>
      <div class="btn" @click.stop="checkScreenCapture">已关闭录屏</div>
    </div>
    <!-- 直播结束弹窗 -->
    <live-end ref="liveEndDialog" v-if="!isRecordPage"></live-end>
    <!-- 移出直播间弹窗 -->
    <kicked ref="kickedDialog" v-if="!isRecordPage"></kicked>
    <!-- 花名册 -->
    <roster v-if="isTeacher || isAssistant" :visible="showRoster" />
    <!-- 共享屏幕弹窗 -->
    <screen-capture-sources
      :visible.sync="screenCaptureSourcesVisible"
      ref="screenCapture"
    ></screen-capture-sources>
    <!-- 屏幕共享时人员列表 -->
    <screen-share-person-list
      v-if="isScreenShare && isElectron"
    ></screen-share-person-list>
    <!-- 多端登陆 -->
    <multi-terminal-login
      ref="multiLogin"
      v-if="!isRecordPage"
    ></multi-terminal-login>
    <open-video />
    <open-audio />
    <change-nickname ref="changeNickname"></change-nickname>
    <interval
      v-if="!isRecordPage"
      :visible.sync="toolboxVisible.interval"
      :toolboxStatus="toolboxStatus.interval"
    ></interval>
    <timeout
      v-if="!isRecordPage"
      :visible.sync="toolboxVisible.timeout"
      :toolboxStatus="toolboxStatus.timeout"
    ></timeout>
    <answer
      v-if="!isStudent && !isRecordPage"
      :visible.sync="toolboxVisible.answerer"
      :toolboxStatus="toolboxStatus.answerer"
    ></answer>
    <student-answer
      v-else-if="!isRecordPage"
      :visible.sync="toolboxVisible.answerer"
      :toolboxStatus="toolboxStatus.answerer"
    ></student-answer>
    <upload-courseware
      :visible.sync="uploadCourseVisible"
      @close="handleCloseUploadCourseware"
      @confirm="handleConfirmSelectCourseware"
    ></upload-courseware>
    <!-- 直播售卖窗口 -->
    <course-sale v-if="!isRecordPage" />
    <!-- 直播售卖购物车 -->
    <shopping-cart v-if="!isRecordPage" />
    <!-- 报错弹窗 -->
    <error ref="errorDialog" v-if="errorVisible && !isRecordPage"></error>
    <!-- 奖杯动画 -->
    <trophy v-if="!isRecordPage && showTrophy.visible" />
    <!-- cdn流错误弹窗 -->
    <cdn-stream-error
      ref="cdnStreamError"
      v-if="showCdnStreamError.visible && !isRecordPage"
    ></cdn-stream-error>
    <dialog-layer />
  </div>
</template>

<script>
import Kicked from "./dialog/Kicked.vue";
import createTrtc from "./mixins/create-trtc.js";
import {
  DragWrap,
  UploadCourseware,
} from "@saas/components";
import LiveSDK from "@saas/live-sdk";
import {
  getRoomInfo,
  getSign,
  getUserStatus,
  startLive,
  liveKeepAlive,
  updateState,
} from "@saas/service-api/src/live-sdk";
import { addFileToRoom } from "@saas/service-api/src/courseware";
import Header from "./components/Header.vue";
import PersonList from "./person-list/Index.vue";
import Bottom from "./components/Bottom.vue";
import DeviceCheck from "./components/DeviceCheck.vue";
import WhiteBoard from "@saas/white-board/src/Index.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { getCourseInfo } from "@saas/service-api/src/product-details";
import { getUserInfo } from "@saas/service-api/src/index";
import { USER_ROLE_NAME } from "@saas/live-sdk/src/services/utils/constants.js";
import DisabledEnter from "./dialog/DisabledEnter.vue";
import LiveEnd from "./dialog/LiveEnd.vue";
import ScreenShare from "./screen-share/ScreenShare.vue";
import ScreenShareMixins from "./mixins/screen-share";
import Roster from "./components/roster/Index.vue";
import ScreenCaptureSources from "./dialog/ScreenCaptureSources.vue";
import ScreenSharePersonList from "./screen-share/ScreenSharePersonList.vue";
import MultiTerminalLogin from "./dialog/MultiTerminalLogin.vue";
// import personList from "./mixins/person-list-new.js";
import toolboxMixin from "./mixins/toolbox.js";
import eventListenerManager from "./mixins/event-listener-manager.js";
import OpenVideo from "./dialog/OpenVideo.vue";
import OpenAudio from "./dialog/OpenAudio.vue";
import ChangeNickname from "./dialog/ChangeNickname.vue";
import Interval from "./toolbox/Interval.vue";
import Timeout from "./toolbox/Timeout.vue";
import Answer from "./toolbox/Answer.vue";
import StudentAnswer from "./toolbox/StudentAnswer.vue";
import CoursewareList from "./components/CoursewareList.vue";
import LiveSet from "./components/live-set/Index.vue";
import CourseSale from "./course-sale/Index.vue";
import ShoppingCart from "./course-sale/ShoppingCart.vue";
import { isAssistant, isTeacher, isEqual } from "./utils/index.js";
import { uploadLiveLog, forceFlushLogs } from "@saas/components/src/utils/log";
import { playMediaSafely } from "@saas/components/src/utils/media-play";
import Watermark from "./components/Watermark.vue";
import Error from "./dialog/Error.vue";
import { LAYOUT_MAP } from "./constants.js";
import Trophy from "./components/trophy/Index.vue";
import CdnStreamError from "./dialog/CdnStreamError.vue";
import { MemberStatusService } from "./services";
import DialogLayer from "./components/dialog-layer/Index.vue";
import {
  addCoursewareToWhiteboard,
  getCoursewareUnavailableReason,
} from "@saas/components/src/utils/courseware";
export default {
  mixins: [
    createTrtc,
    ScreenShareMixins,
    // personList,
    toolboxMixin,
    eventListenerManager,
  ],
  components: {
    "live-header": Header,
    PersonList,
    Bottom,
    WhiteBoard,
    DeviceCheck,
    LiveSet,
    DragWrap,
    DisabledEnter,
    LiveEnd,
    Kicked,
    ScreenShare,
    Roster,
    ScreenCaptureSources,
    ScreenSharePersonList,
    MultiTerminalLogin,
    OpenVideo,
    OpenAudio,
    ChangeNickname,
    Interval,
    Timeout,
    Answer,
    CourseSale,
    ShoppingCart,
    StudentAnswer,
    UploadCourseware,
    CoursewareList,
    Error,
    Watermark,
    Trophy,
    CdnStreamError,
    DialogLayer,
  },
  props: {
    isWin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lessonId: null,
      courseId: null,
      liveSDK: null,
      // imService: null,
      // im相关 ready
      isImReady: false,
      messageList: [],
      isElectron: !!window.isElectron,
      isLoading: true,
      settingVisible: false,
      isShowDisabledCapture: false,
      isShowDisabledCaptureTips: false,
      isShowDisabledCaptureTipsTimer: null,
      resizeBarWidthDebounceTimer: null,
      resizeBarObserver: null,
      initSetActive: null,
      screenCaptureSourcesVisible: false,
      isRecordPage: false,
      // 是否广播
      isBroadcastScreenShareStatus: true,
      uploadCourseVisible: false,
      keepAliveTimer: null,
      announcementScrollInstance: null,
      marqueeInstance: null,
      // 成员状态服务
      memberStatusService: null,
      // 屏幕共享播放按钮状态
      screenShareShowPlayButton: false,
      coursewareVideoVolumeTimer: null,
      coursewareVideoVolumeApplyTimer: null,
      coursewareVideoVolumeState: null,
      wasDarkThemeBeforeLive: false,
    };
  },
  watch: {
    userStatus: {
      handler(val, oldVal) {
        // 判断是否变化
        console.log("new_live_usertatus-watch-val", { ...val });
        if (isEqual(val, oldVal)) {
          return;
        }
        console.log("new_live_usertatus-watch-val-change", { ...val });
        if (
          this.imService &&
          this.isImReady &&
          val &&
          this.liveService.isEnterRoomSuccess
        ) {
          this.imService.sendMGLiveRoomCustomMsg({
            cmdId: 2,
            data: {
              type: "userStatus",
              data: val,
            },
          });
        }
        // if (val) {
        //   this.updateAllMemberStatus(val);
        // }
        if (val && this.memberStatusService) {
          this.memberStatusService.updateUserStatus({
            ...val,
          });
        }
      },
      deep: true,
    },
    "userStatus.audio_state": {
      handler(val) {
        if (this.roomInfo.id) {
          updateState({
            audio_state: val,
            room_id: this.roomInfo.id,
          });
        }
      },
      immediate: true,
    },
    liveService: {
      handler(val) {
        if (val) {
          this.handleLiveServiceListener();
        }
      },
    },
    screenShareStatus(val) {
      if (!val) return;
      if (this.isBroadcastScreenShareStatus) {
        this.broadcastScreenShareStatus();
      } else {
        this.isBroadcastScreenShareStatus = true;
      }
      if (["start", "pause"].includes(val)) {
        // this.dealScreenShareWhiteBoardClick();
        // 停止访录屏
        if (window.LiveElectronApi) {
          window.LiveElectronApi.screenCaptureSwitch({
            isEnter: true,
            disableRecord: false,
          });
        }
      } else {
        this.initScreenCaptrue();
      }
    },
    showEmbedChat(val, oldVal) {
      this.onShowChatChange(val, oldVal);
    },
    showSet: {
      handler(val) {
        this.settingVisible = val.visible;
        this.initSetActive = val.initActive;
      },
      deep: true,
    },
    showScreenShareDialog(val) {
      this.screenCaptureSourcesVisible = val;
    },
    videoPermission: {
      handler(newVal) {
        if (!newVal) {
          this.setUserStatus({
            video_state: 2,
          });
        }
      },
      immediate: true,
    },
    isScreenShareRemote(val) {
      if (val) {
        // 如果后面有人开始共享 结束本地共享
        if (this.isScreenShare) {
          this.isCloseShare = true;
          this.onLocalScreenShareStop(false);
        }
      }
    },
    showChangeNickname(val) {
      if (val.visible) {
        this.$refs.changeNickname.open();
      }
    },
    showToolbox(val) {
      // 更新工具箱可见状态
      this.toolboxVisible.interval = !!val.interval;
      this.toolboxVisible.timeout = !!val.timeout;
      this.toolboxVisible.answerer = !!val.answerer;
    },
    showUploadCourseware(val) {
      this.uploadCourseVisible = val;
    },
    errorVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.errorDialog.open();
        });
      }
    },
    // 监听服务就绪状态
    liveAndImIsReady(val) {
      if (val) {
        this.initServices();
        this.initBroadcast();
        this.initOpenMicOrCamera();
      }
    },
    networkOnline: {
      handler(val) {
        uploadLiveLog({
          message: "networkOnline 发生变化",
          level: "info",
          tag: "api",
          extra: {
            component: "Index",
            action: "networkOnlineChange",
            val: val,
          },
        });
      },
    },
    isStudentDownstageCDN: {
      handler(val) {
        this.dynamicCreateWhiteBoard();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("live", [
      "isReady",
      "layout",
      "roomInfo",
      "signConfig",
      "deviceSwtich",
      "userStatus",
      // "members",
      "liveService",
      "courseInfo",
      "whiteToolbarKey",
      "screenShareStatus",
      "remoteScreenShareInfo",
      "showSet",
      "showRoster",
      "showScreenShareDialog",
      "screenSharePreInfo",
      "showDeviceCheck",
      "videoPermission",
      "showChangeNickname",
      "showToolbox",
      // "allMemberStatus",
      "showUploadCourseware",
      "whiteboardType",
      "imService",
      "whiteBoardService",
      "errorVisible",
      "showTrophy",
      "showCdnStreamError",
      "videoPermission",
      "audioPermission",
      "networkOnline",
    ]),
    ...mapState("newChat", ["showChat", "chatMode"]),
    ...mapGetters("live", ["liveAndImIsReady"]),
    // 是否展示分栏聊天框
    showEmbedChat() {
      return this.showChat && this.chatMode === "embed";
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    isReady() {
      return this.isImReady;
    },
    isWhiteBoard() {
      return this.userStatus?.is_whiteboard === 1 && !this.isScreenShareRemote;
    },
    isStudent() {
      return USER_ROLE_NAME[this.userStatus?.user_role] === "student";
    },
    isTeacher() {
      return USER_ROLE_NAME[this.userStatus?.user_role] === "teacher";
    },
    isAssistant() {
      return USER_ROLE_NAME[this.userStatus?.user_role] === "assistant";
    },

    // 1 大班课 2小班课
    roomType() {
      return this.roomInfo.room_type;
    },
    // 几v几
    goodsRoomType() {
      return this.roomInfo.goods_room_type;
    },
    // header组件展示条件
    showHeader() {
      if (this.isRecordPage) {
        return false;
      } else if (this.isElectron) {
        return this.screenShareStatus === "end";
      } else {
        return true;
      }
    },
    // bottom 组件展示条件
    showBottom() {
      if (this.isRecordPage) {
        return false;
      } else if (this.isElectron) {
        return this.screenShareStatus === "end";
      } else {
        return true;
      }
    },
    // 共享组件展示条件 共享中或者暂停共享，或者接受共享()
    showScreenShare() {
      // 大班课下台学生始终显示 ScreenShare 组件（用于 CDN 流播放）
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      ) {
        return true;
      }
      return this.isScreenShare || this.isScreenShareRemote;
    },
    // 共享端是否展示白板
    isShowScreenShareWhiteboard() {
      return this.screenSharePreInfo.isWhiteboard;
    },
    // 接收共享端是否展示白板
    isShowScreenShareWhiteboardRemote() {
      return this.remoteScreenShareInfo.isWhiteboard;
    },
    // 是否在共享(共享端)
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
    // 屏幕共享白板群组id
    screenShareWhiteboardGroupId: () => "screenShare",
    // 是否开启风险防控的机构水印开关
    isRiskControlOrgWatermarkSwitch() {
      return (
        this.roomInfo.risk_control_config?.org_watermark_switch === 1 &&
        this.roomInfo.risk_control_switch === 1
      );
    },
    // 判断是否为学生下台使用CDN流的情况
    isStudentDownstageCDN() {
      return (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      );
    },
  },
  created() {
    this.wasDarkThemeBeforeLive =
      document.documentElement.classList.contains("dark");
    document.documentElement.classList.add("dark");
    this.memberStatusService = new MemberStatusService(this.$store);
    if (!this.isElectron) {
      this.getWebPermission();
    } else {
      this.getElectronPermission();
    }
  },
  mounted() {
    this.lessonId = +this.$route.params.lessonId || "";
    this.courseId = this.$route.params.courseId || "";
    this.isRecordPage = !!this.$route.query.token;
    this.setCourseId(this.courseId);
    this.setLessonId(this.lessonId);
    this.setIsRecordPage(this.isRecordPage);
    if (this.isRecordPage) {
      getUserInfo().then((res) => {
        if (res.code === 1) {
          this.$store.commit("user/SET_USER_INFO", res.data);
          this.init();
        }
      });
    } else {
      if (this.isElectron) {
        this.electronInit();
      } else {
        this.webInit();
      }
    }
    this.initResizeBarObserver();
  },
  beforeDestroy() {
    this.imService?.destroy();
    if (!this.wasDarkThemeBeforeLive) {
      document.documentElement.classList.remove("dark");
    }
    if (this.liveService) {
      this.liveService.exitRoom();
    }
    this.removeResizeBarObserver();
    clearInterval(this.keepAliveTimer);
    clearTimeout(this.isShowDisabledCaptureTipsTimer);
    clearTimeout(this.resizeBarWidthDebounceTimer);
    clearTimeout(this.coursewareVideoVolumeTimer);
    clearTimeout(this.coursewareVideoVolumeApplyTimer);
    if (this.marqueeInstance) {
      this.marqueeInstance.destroy();
    }
    if (this.announcementScrollInstance) {
      this.announcementScrollInstance.destroy();
    }
    // 清理成员状态服务
    if (this.memberStatusService) {
      this.memberStatusService.destroy();
      this.memberStatusService = null;
    }
  },
  methods: {
    ...mapActions("live", ["initPersistedData"]),
    ...mapMutations("live", [
      "setCameraList",
      "setWhiteBoardService",
      "setImService",
      "setMicrophoneList",
      "setIsReady",
      "setSpeakerList",
      "setSignConfig",
      "setRoomInfo",
      "setUserStatus",
      "setCourseInfo",
      "setLayout",
      "setVideoPermission",
      "setAudioPermission",
      "setScreenPermission",
      "setScreenShareStatus",
      "setRemoteScreenShareInfo",
      "setShowRoster",
      "setShowDeviceCheck",
      // "setAllMemberStatus",
      "setShowUploadCourseware",
      "setWhiteboardType",
      "setIsRecordPage",
      "setAllMemberStatusMap",
      "setErrorInfo",
      "setErrorVisible",
      "setShowTrophy",
      "setCourseId",
      "setLessonId",
      "setShowOpenVideoDialog",
      "setShowOpenAudioDialog",
    ]),
    ...mapMutations("whiteBoard", ["setRole"]),
    ...mapMutations("newChat", ["SET_CHAT_MODE"]),
    /**
     * 初始化所有服务
     */
    initServices() {
      const userStatus = this.userStatus;
      // 初始化成员状态服务
      if (
        this.memberStatusService &&
        this.imService &&
        this.liveService &&
        userStatus
      ) {
        this.memberStatusService.init(
          this.imService,
          this.liveService,
          userStatus
        );
        this.memberStatusService.onEnterRoomSuccess();
      }
    },
    /**
     * 初始化完成后广播
     */
    initBroadcast() {
      if (this.isReady && this.imService) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "initUserStatus",
            data: {
              ...this.userStatus,
            },
          },
        });
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "userStatus",
            data: {
              ...this.userStatus,
            },
          },
        });
        uploadLiveLog({
          message: "initUserStatus",
          level: "info",
          tag: "api",
          extra: {
            component: "Index",
            action: "initBroadcast",
            userStatus: this.userStatus,
          },
        });
      }
    },
    /**
     * 初始化打开麦克风或者摄像头
     */
    initOpenMicOrCamera() {
      // 只有学生需要初始化打开麦克风或者摄像头需要有弹窗提示
      if (this.userStatus.is_up_stage === 1 && this.roomInfo.isStudent) {
        if (this.userStatus.is_send_audio === 1 && this.audioPermission) {
          this.setShowOpenAudioDialog(true);
          uploadLiveLog({
            message: "initOpenMicOrCamera-setShowOpenAudioDialog-true",
            level: "info",
            tag: "api",
            extra: {
              component: "Index",
              action: "initOpenMicOrCamera",
            },
          });
        }
        if (this.userStatus.is_send_video === 1 && this.videoPermission) {
          this.setShowOpenVideoDialog(true);
          uploadLiveLog({
            message: "initOpenMicOrCamera-setShowOpenVideoDialog-true",
            level: "info",
            tag: "api",
            extra: {
              component: "Index",
              action: "initOpenMicOrCamera",
            },
          });
        }
      }
    },
    // 监听resizeBar宽度变化
    initResizeBarObserver() {
      const resizeBar = this.$el.querySelector(".resize-bar");
      if (resizeBar) {
        this.resizeBarObserver = new ResizeObserver((entries) => {
          if (!entries.length) return;
          const width = entries[0].contentRect.width;
          this.handleResizeBarWidthChange(width);
        });
        this.resizeBarObserver.observe(resizeBar);
      }
    },
    // 移除resizeBar宽度变化监听
    removeResizeBarObserver() {
      if (this.resizeBarObserver) {
        this.resizeBarObserver.disconnect();
        this.resizeBarObserver = null;
      }
      if (this.resizeBarWidthDebounceTimer) {
        clearTimeout(this.resizeBarWidthDebounceTimer);
        this.resizeBarWidthDebounceTimer = null;
      }
    },
    // 网页端获取设备权限
    getWebPermission() {
      // navigator.mediaDevices
      //   .getUserMedia({
      //     video: true, // 请求摄像头
      //     audio: true, // 请求麦克风
      //   })
      //   .then((stream) => {
      //     // 成功获取媒体流后，将其绑定到视频元素
      //     this.initPersistedData();
      //   })
      //   .catch((error) => {
      //     // 处理权限请求错误
      //     // this.$darkMessage.error("请打开摄像头和麦克风权限");
      //   });
    },
    // 客户端或者设备权限
    async getElectronPermission() {
      try {
        const cameraPermission = await window.ipcRenderer.invoke(
          "getMediaAccessStatus",
          {
            mediaType: "camera",
          }
        );
        const micPermission = await window.ipcRenderer.invoke(
          "getMediaAccessStatus",
          {
            mediaType: "microphone",
          }
        );
        const screenPermission = await window.ipcRenderer.invoke(
          "getMediaAccessStatus",
          {
            mediaType: "screen",
          }
        );
        console.log("cameraPermission", cameraPermission);
        console.log("cameraPermission", micPermission);
        console.log("screenPermission", screenPermission);
        this.setVideoPermission(cameraPermission);
        this.setAudioPermission(micPermission);
        this.setScreenPermission(screenPermission);
        this.initPersistedData();
        uploadLiveLog({
          message: "客户端用户初始化获取设备权限---成功",
          tag: "init",
          extra: {
            component: "Index",
            cameraPermission,
            micPermission,
            screenPermission,
          },
        });
      } catch (error) {
        console.error(error);
        uploadLiveLog({
          message: "客户端用户初始化获取设备权限---失败",
          tag: "init",
          level: "error",
          extra: {
            component: "Index",
            error: error,
          },
        });
        this.$darkMessage.error("获取设备权限失败");
      }
    },
    webInit() {
      this.init();
      window.addEventListener("beforeunload", (event) => {
        if (this.liveService) {
          this.liveService.exitRoom();
        }
        forceFlushLogs();
      });
    },
    electronInit() {
      getUserInfo()
        .then((res) => {
          if (res.code === 1) {
            this.$store.commit("user/SET_USER_INFO", res.data);
            this.init();
            uploadLiveLog({
              message: "客户端用户初始化获取用户信息---成功",
              tag: "init",
              extra: {
                component: "Index",
              },
            });
          } else {
            this.$darkMessage.error(res.message);
            uploadLiveLog({
              message: "客户端用户初始化获取用户信息---失败",
              tag: "init",
              extra: {
                component: "Index",
                message: res.message,
              },
            });
          }
        })
        .catch(() => {
          this.$darkMessage.error("获取用户信息失败");
          uploadLiveLog({
            message: "客户端用户初始化获取用户信息---接口请求失败",
            tag: "init",
            extra: {
              component: "Index",
              message: "接口请求失败",
            },
          });
        });
      // 渲染进程（页面中）
      window.addEventListener("beforeunload", (event) => {
        if (this.liveService) {
          this.liveService.exitRoom();
        }
        this.setScreenShareStatus("end");
        // 不要返回提示信息（否则会弹出确认框）
        // 直接执行代码即可
      });
    },
    handleWhiteBoardError() {
      this.$darkMessage.error("白板出错啦，请刷新页面重试");
    },
    sendMessageUseIm(data) {
      if (!this.imService.isReady) {
        this.imService.once("ready", () => this.sendMessageUseIm(data));
        return;
      }
      const message = this.imService.createCustomMessage({
        to: this.roomInfo.id + "",
        conversationType: 2,
        priority: "high", // 因为im消息有限频，白板消息的优先级调整为最高
        payload: {
          data: JSON.stringify(data),
          description: "",
          extension: "TXWhiteBoardExt", // 固定写法，各端会以extension: 'TXWhiteBoardExt'为标志作为白板信令
        },
      });
      this.imService
        .sendMessage(message, {
          webhookInfo: {
            disableCloudMessagePreHook: true,
            disableCloudMessagePostHook: true,
          },
        })
        .then(
          () => {
            // 同步成功
            console.log("发送消息成功");
          },
          () => {
            // 同步失败
            console.log("发送消息失败");
          }
        );
    },
    handleShowSetting() {
      this.settingVisible = !this.settingVisible;
    },
    async init() {
      try {
        this.getCourseInfo();
        const isOk = await this.getSignature();
        if (!isOk) {
          return;
        }
        this.liveKeepAlive();
        await this.getRoomInfo();
        await this.getUserStatus(this.roomInfo.id);
        if (!this.isStudent) {
          this.setShowDeviceCheck({
            visible: true,
            type: "init",
          });
          this.createServices();
        } else {
          this.createTrtc();
          this.createServices();
        }
        this.dynamicCreateWhiteBoard();
        this.setDefaultLayout();
        // 初始化工具箱状态
        await this.initToolboxStatus();
        this.initScreenCaptrue();
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 心跳
    liveKeepAlive() {
      try {
        clearInterval(this.keepAliveTimer);
        this.keepAliveTimer = setInterval(() => {
          liveKeepAlive({
            client_type: 1,
            course_id: this.courseId,
            lesson_id: this.lessonId,
            play_time: Date.now(),
            user_sig: this.signConfig?.live_sig?.user_sig,
          });
        }, 1000 * 60);
      } catch (error) {
        console.error(error);
      }
    },
    // 获取房间信息
    async getRoomInfo() {
      try {
        let { code, data, message } = await getRoomInfo({
          lesson_id: this.lessonId,
        });
        if (code === 1) {
          data.isTeacher = isTeacher(this.userInfo.user_id, data);
          data.isAssistant = isAssistant(this.userInfo.user_id, data);
          data.isStudent = !data.isTeacher && !data.isAssistant;
          console.log("data>>", data.isTeacher);
          console.log("data>>", data.isAssistant);
          this.setRoomInfo(data || {});
          uploadLiveLog({
            message: "获取房间信息---成功",
            extra: {
              component: "Index",
              roomInfo: data,
            },
          });
        } else {
          this.$darkMessage.error(message);
          uploadLiveLog({
            message: "获取房间信息---失败",
            level: "error",
            extra: {
              component: "Index",
              message: message,
              code: code,
            },
          });
        }
      } catch (error) {
        console.error(error);
        uploadLiveLog({
          message: "获取房间信息---失败",
          level: "error",
          extra: {
            component: "Index",
            error: error,
          },
        });
      }
    },
    // 获取用户状态
    async getUserStatus(roomId) {
      try {
        const {
          code,
          message,
          data = {},
        } = await getUserStatus({
          room_id: roomId,
        });
        if (code === 1) {
          if (data.is_permanent_remove === 1 && !this.roomInfo.isTeacher) {
            // 禁止进入直播间
            this.$refs.disabledEnterDialog.open();
            return;
          }
          this.initSelfStatus(data);
          this.setRole(data?.user_role || 3);
          uploadLiveLog({
            message: "获取用户状态---成功",
            tag: "init",
            extra: {
              component: "Index",
              userStatus: data,
            },
          });
        } else {
          this.$darkMessage.error(message);
          uploadLiveLog({
            message: "获取用户状态---失败",
            level: "error",
            extra: {
              component: "Index",
              message: message,
              code: code,
            },
          });
        }
      } catch (error) {
        uploadLiveLog({
          message: "获取用户状态---失败",
          level: "error",
          extra: {
            component: "Index",
            error: error,
          },
        });
      }
    },
    // 初始化处理自己的状态
    initSelfStatus(data = {}) {
      if (
        this.roomInfo.isTeacher ||
        (this.roomInfo.isAssistant && data.is_up_stage === 1)
      ) {
        // 当前用户是老师/助教并且有权限自动上台, 有权限并且打开摄像头和麦克风
        const audioState =
          this.deviceSwtich.microphone === "on" && this.audioPermission ? 1 : 2;
        const videoState =
          this.deviceSwtich.camera === "on" && this.videoPermission ? 1 : 2;
        const status = {
          is_up_stage: 1,
          is_send_audio: 1,
          is_send_video: 1,
          audio_state: audioState,
          video_state: videoState,
        };
        if (this.roomInfo.mode == 1) {
          status.video_state = 2;
        }
        this.setUserStatus({
          ...data,
          ...status,
        });
      } else {
        this.setUserStatus({
          ...data,
          audio_state: 2,
          video_state: 2,
        });
      }
    },
    // 获取课程信息
    getCourseInfo() {
      try {
        if (!this.courseId) return;
        getCourseInfo({
          course_id: this.courseId,
        })
          .then((res) => {
            if (res.code === 1) {
              this.setCourseInfo(res.data || {});
              uploadLiveLog({
                message: "用户初始化获取课程信息---成功",
                tag: "init",
                extra: {
                  component: "Index",
                },
              });
            } else {
              this.$darkMessage.error(res.message);
              uploadLiveLog({
                message: "用户初始化获取课程信息---失败",
                tag: "init",
                level: "error",
                extra: {
                  component: "Index",
                  message: res.message,
                  code: res.code,
                },
              });
            }
          })
          .catch((error) => {
            console.error(error);
            this.$darkMessage.error("获取课程信息失败");
            uploadLiveLog({
              message: "用户初始化获取课程信息---接口请求失败",
              tag: "init",
              level: "error",
              extra: {
                component: "Index",
                message: "接口请求失败",
                error: error,
              },
            });
          });
      } catch (error) {
        console.error(error);
        this.$darkMessage.error("获取课程信息失败");
        uploadLiveLog({
          message: "用户初始化获取课程信息---失败",
          tag: "init",
          level: "error",
          extra: {
            component: "Index",
            message: "接口请求失败",
            error: error,
          },
        });
      }
    },
    // 设置访录屏幕权限
    async initScreenCaptrue() {
      this.isShowDisabledCapture = false;
      // 不是录屏页才需要设置访录屏幕权限
      if (this.roomInfo.risk_control_switch === 1 && !this.isRecordPage) {
        // 是否开启风险防控
        if (window.isElectron) {
          // 客户端
          const disabledScreenCapture =
            this.roomInfo.risk_control_config &&
            this.roomInfo.risk_control_config.recording_screen_switch === 1;
          // 是否开启访录屏
          window.LiveElectronApi.screenCaptureSwitch({
            isEnter: true,
            disableRecord: disabledScreenCapture,
          });
          if (window.ipcRenderer) {
            this.registerIpcRendererListener("home-watcher", (event, arg) => {
              this.isShowDisabledCapture = arg;
            });
          }
          uploadLiveLog({
            message: "客户端设置访录屏幕权限",
            extra: {
              component: "Index",
              action: "initScreenCaptrue",
              disabledScreenCapture: disabledScreenCapture,
            },
          });
        } else {
          // 网页端
          const webFirewallSwitch =
            this.roomInfo.risk_control_config &&
            this.roomInfo.risk_control_config.web_firewall_switch === 1;
          if (webFirewallSwitch) {
            this.$router.replace("/firewall/" + this.courseId);
          }
        }
      }
      uploadLiveLog({
        message: "设置访录屏幕权限",
        extra: {
          component: "Index",
          action: "initScreenCaptrue",
          riskControlSwitch: this.roomInfo.risk_control_switch,
        },
      });
    },
    // 在次检测
    async checkScreenCapture() {
      const res = await window.ipcRenderer.invoke("checkScreenCapture");
      if (res) {
        this.isShowDisabledCapture = true;
        this.isShowDisabledCaptureTips = true;
        clearTimeout(this.isShowDisabledCaptureTipsTimer);
        this.isShowDisabledCaptureTipsTimer = setTimeout(() => {
          this.isShowDisabledCaptureTips = false;
        }, 3000);
      } else {
        this.isShowDisabledCapture = false;
      }
      uploadLiveLog({
        message: "客户端点击检测访录屏幕权限按钮",
        extra: {
          component: "Index",
          action: "checkScreenCapture",
          res: res,
          isShowDisabledCapture: this.isShowDisabledCapture,
        },
      });
    },

    //
    async getSignature() {
      try {
        const { code, data, message } = await getSign({
          lesson_id: this.lessonId,
          first_join: 1,
        });
        if (code === 1) {
          this.setSignConfig(data || {});
          uploadLiveLog({
            message: "用户初始化获取签名---成功",
            tag: "init",
            extra: {
              component: "Index",
            },
          });
          return true;
        } else if (code === 21003) {
          this.$refs.liveEndDialog.open();
        } else if (code === 21001) {
          this.$refs.kickedDialog.open();
        } else {
          this.$darkMessage.error(message);
        }
        uploadLiveLog({
          message: "用户初始化获取签名---失败",
          tag: "init",
          extra: {
            component: "Index",
            message: message,
            code: code,
          },
        });
        return false;
      } catch (error) {
        console.error(error);
        uploadLiveLog({
          message: "用户初始化获取签名---失败",
          tag: "init",
          level: "error",
          extra: {
            error: error,
          },
        });
      }
    },
    // 创建rtc im 白板
    createServices() {
      try {
        const signConfig = this.signConfig;
        const liveSign = signConfig.live_sig;
        const tiwSign = signConfig.board_sig;
        const userId = signConfig.user_id;
        const config = {
          providers: {
            live: "trtc",
            im: "tim",
            whiteboard: "tiw",
          },
          // live: {
          //   trtc: {
          //     sdkAppId: liveSign.sdk_app_id,
          //     userSig: liveSign.user_sig,
          //     userId: userId,
          //     roomId: this.roomInfo.id,
          //     role: 1,
          //   },
          // },
          // whiteboard: {
          //   tiw: {
          //     id: "comp-container__white-board-sketch", // dom节点id
          //     classId: this.roomInfo.id, // 课堂 ID，32位整型，取值范围[1, 4294967294]
          //     sdkAppId: tiwSign.sdk_app_id, // 整数
          //     userId: userId, // 字符串
          //     userSig: tiwSign.user_sig, // 字符串
          //   },
          // },
          im: {
            tim: {
              sdkAppId: tiwSign.sdk_app_id,
              userID: userId,
              userSig: tiwSign.user_sig,
              classId: this.roomInfo.id,
              lessonId: this.lessonId,
              isStudent: this.roomInfo.isStudent,
              isTeacher: this.roomInfo.isTeacher,
              isAssistant: this.roomInfo.isAssistant,
            },
          },
        };
        this.liveSDK = LiveSDK.init(config);
        // const whiteBoardService = this.liveSDK.getService("whiteboard");
        const imService = this.liveSDK.getService("im");
        this.setImService(imService);
        // this.setWhiteBoardService(whiteBoardService);
        this.handleImServiceListener();
        // this.handleWhiteBoardListener();
      } catch (error) {
        uploadLiveLog({
          message: "创建 im 白板---失败",
          level: "error",
          extra: {
            component: "Index",
            error: error,
          },
        });
      }
    },
    // 动态创建白板或着销毁白板
    dynamicCreateWhiteBoard() {
      try {
        if (!this.isStudentDownstageCDN) {
          this.createWhiteBoard();
          uploadLiveLog({
            message: "动态创建白板",
            level: "info",
            extra: {
              component: "Index",
              action: "dynamicCreateWhiteBoard",
            },
          });
        } else {
          this.whiteBoardService?.destroy();
          uploadLiveLog({
            message: "动态销毁白板",
            level: "info",
            extra: {
              component: "Index",
              action: "dynamicCreateWhiteBoard",
            },
            val: this.isStudentDownstageCDN,
          });
        }
      } catch (error) {
        uploadLiveLog({
          message: "动态创建白板或着销毁白板---失败",
          level: "error",
          extra: {
            component: "Index",
            error: error,
          },
        });
      }
    },
    // 创建白板
    createWhiteBoard() {
      try {
        const signConfig = this.signConfig;
        const liveSign = signConfig.live_sig;
        const tiwSign = signConfig.board_sig;
        const userId = signConfig.user_id;
        const config = {
          providers: {
            live: "trtc",
            im: "tim",
            whiteboard: "tiw",
          },
          whiteboard: {
            tiw: {
              id: "comp-container__white-board-sketch", // dom节点id
              classId: this.roomInfo.id, // 课堂 ID，32位整型，取值范围[1, 4294967294]
              sdkAppId: tiwSign.sdk_app_id, // 整数
              userId: userId, // 字符串
              userSig: tiwSign.user_sig, // 字符串
            },
          },
        };
        this.liveSDK = LiveSDK.init(config);
        const whiteBoardService = this.liveSDK.getService("whiteboard");
        this.setWhiteBoardService(whiteBoardService);
        this.handleWhiteBoardListener();
      } catch (error) {
        uploadLiveLog({
          message: "创建 白板---失败",
          level: "error",
          extra: {
            component: "Index",
            error: error,
          },
        });
      }
    },
    // trtc的监听事件
    handleLiveServiceListener() {
      this.registerLiveServiceListeners({
        enterRoomFail: this.handleError,
        cameraError: this.handleError,
        microphoneError: this.handleError,
        speakerError: this.handleError,
        screenShareError: this.handleError,
        enterRoomSuccess: this.onEnterRoomSuccess,
        kickedOut: (event) => {
          console.log("被踢出房间", event);

          // this.$darkMessage.error(event);
          if (event === "room_disband") {
            this.$refs.liveEndDialog.open();
            this.closeNewChatPopup();
            if (window.isElectron) {
              window.ipcRenderer.send("end-class", {
                lessonId: this.lessonId,
                courseId: this.roomInfo.course_id,
              });
            } else {
              void playMediaSafely(this.$endClassBell);
            }
          }
          uploadLiveLog({
            message: "被踢出房间",
            level: "callback",
            extra: {
              component: "Index",
              event: event,
            },
          });
        },
        screenShareStop: (event) => {
          // SDK 检测到浏览器原生停止共享，track 已自动清理
          this.onLocalScreenShareStop(true, true);
        },
        // remoteUserEnterRoom: (res) => {
        //   if (this.isScreenShare) {
        //     this
        //   }
        // },
      });
    },
    // 进入房间成功
    onEnterRoomSuccess() {
      // 进入房间后
      console.log("onEnterRoomSuccess_____", this.isStudentDownstageCDN);
      console.log("发送消息·");
      if (!this.isStudent && !this.roomInfo.room_start_time) {
        // 如果是老师并且未开始直播，调用开始直播接口
        startLive({
          lesson_id: this.lessonId,
        }).then((res) => {
          if (res.code !== 1) {
            this.$darkMessage.error(res.message);
          } else {
            this.getRoomInfo();
          }
        });
      }
      // 发送用户信息
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "userInfo",
          data: {
            userId: this.userInfo.user_id,
            avatar: this.userInfo.avatar,
            nickname: this.userStatus.nickname,
          },
        },
      });
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "courseInfo",
          data: {
            id: this.roomInfo.course_id,
            course_name: this.courseInfo.course_name,
            enrollment_count: this.roomInfo.enrollment_count,
          },
        },
      });
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "xhRemoteEnterRoom",
          data: {
            userId: this.userInfo.user_id,
            time: Math.floor(Date.now() / 1000),
            nickname: this.userStatus.nickname,
          },
        },
      });
      uploadLiveLog({
        message: "进入房间成功",
        level: "info",
        extra: {
          component: "Index",
        },
      });
    },
    // 错误
    handleError(params) {
      this.setErrorVisible(true);
      this.setErrorInfo({
        errorMessage: params.errMsg || "未知错误",
        errorCode: params.errCode,
        errorType: params.errType,
      });
      if (
        window.isElectron &&
        params.errType === "screenShare" &&
        this.isScreenShare
      ) {
        // 录屏错误 结束共享
        this.onLocalScreenShareStop();
      }
      uploadLiveLog({
        message: "错误",
        level: "error",
        extra: {
          component: "Index",
          error: params,
        },
      });
    },
    // 当本地分享结束
    // fromSDKEvent: 是否由 SDK 的 SCREEN_SHARE_STOPPED 事件触发（浏览器原生"停止共享"按钮）
    // 当浏览器原生停止时，SDK 已自动清理了 screenaudio，
    // 不应再调 stopScreenCapture() 避免双重清理导致主音频轨道被误杀
    onLocalScreenShareStop(isBroadcast = true, fromSDKEvent = false) {
      uploadLiveLog({
        message: "屏幕共享结束",
        tag: "api",
        extra: { component: "Index", fromSDKEvent },
      });
      if (window.isElectron) {
        this.liveService.stopSystemAudioLoopback();
        this.liveService.stopScreenCapture();
        window.LiveElectronApi.toggleOnTop(false);
        window.LiveElectronApi.setResizable(true);
        window.LiveElectronApi.setIgnoreMouseEvents(false);
        this.setPosition();
        this.dealScreenShareWhiteBoard();
        // 停止白板位置同步
        this.stopSetIgnoreMouseEventsSync();
        window.ipcRenderer.send("chat-state-update", {
          screenShareStatus: "end",
          type: "screenShareStatus",
        });
      } else if (!fromSDKEvent) {
        // 手动点击"停止共享"按钮，需要主动调 stopScreenCapture
        this.liveService.stopScreenCapture();
      }
      // fromSDKEvent=true 时，SDK 已自动处理了 track 清理，无需再调 stopScreenCapture
      this.isBroadcastScreenShareStatus = isBroadcast;
      this.setScreenShareStatus("end");
      if (window.ipcRenderer) {
        try {
          window.ipcRenderer.send("stop-get-all-system-windows");
        } catch (e) {
          console.warn("停止共享窗口轮询失败", e);
        }
      }
    },
    // 设置窗口位置
    setPosition() {
      const position = this.screenSharePreInfo.position;
      const size = this.screenSharePreInfo.size;
      console.log("还原窗口位置，大小");

      console.log(position);
      console.log(size);

      window.LiveElectronApi.setWindowSize(size[0], size[1]);
      window.LiveElectronApi.setPosition(position[0], position[1]);
    },
    // im的监听事件
    handleImServiceListener() {
      if (this.imService) {
        this.registerImServiceListeners({
          recvMGLiveRoomCustomMsg: (res) => {
            this.handleLiveRoomCustomMsg(res);
          },
          ready: () => {
            console.log("im ready");
            this.isImReady = true;
            this.setIsReady(this.isImReady);
            this.setUserStatus({
              update: Date.now(),
            });
            if (this.roomInfo.isStudent) {
              // 非老师/助教自动加入房间
              this.handleEnterRoom();
            }
          },
          notReady: (res) => {
            console.log("djj____im not ready");
            this.isImReady = false;
            this.setIsReady(this.isImReady);
          },
          boardMessageReceived: (res) => {
            if (!this.isStudentDownstageCDN) {
              this.whiteBoardService.addSyncData(res);
            }
          },
          kickedOut: (reason) => {
            this.onImServiceKickout(reason);
          },
        });
      } else {
        console.error("imService__未准备好");
      }
    },
    // im被踢
    onImServiceKickout(reason) {
      console.log("djj____onImServiceKickout", reason);
      if (["web", "platform"].includes(reason)) {
        // 多页面或者多端登陆
        clearInterval(this.keepAliveTimer);
        this.$refs.multiLogin.open();
        this.closeNewChatPopup();
        this.liveService.exitRoom();
        if (this.isScreenShare) {
          this.onLocalScreenShareStop();
        }
        this.liveService.stopLocalPreview();
      } else if (["api"].includes(reason)) {
        // 接口踢出
      } else if (["expire"].includes(reason)) {
        // 签名过期
      }
      if (this.isScreenShare) {
        this.liveService.stopSystemAudioLoopback();
        this.liveService.stopScreenCapture();
      }
    },
    // 白板的监听事件
    handleWhiteBoardListener() {
      this.registerWhiteBoardServiceListeners({
        ready: () => {
          this.dealScreenShareWhiteBoard();
        },
      });
    },
    // 监听直播间自定义消息
    handleLiveRoomCustomMsg(res) {
      console.log("==live___handleLiveRoomCustomMsg", res);
      const { data, userId } = res;
      switch (data?.type) {
        case "courseInfo":
          this.onReciveCourseInfo(data);
          break;
        case "endLive":
          this.onReciveEndLive(data);
          break;
        case "xhRemoteEnterRoom":
          this.onReciveXHRemoteEnterRoom(data);
          break;
        case "screenShare":
          this.onReciveScreenShare(data);
          break;
        case "updateNickname":
          // this.onReceiveUpdateNickname(data);
          if (window.ipcRenderer) {
            window.ipcRenderer.send("update-nickname", data.data);
          }
          break;
        case "whiteboardType":
          this.onReceiveUpdateWhiteboardType(data);
          break;
        case "coursewareUpdate":
          this.onReceiveUpdateCourseware();
          break;
        case "coursewareVideoVolume":
          this.onReceiveCoursewareVideoVolume(data, userId);
          break;
        case "learnModeChange":
          this.onReceiveLearnModeChange(data);
          break;
        // case "layoutChange":
        //   this.onReceiveLayoutChange(data);
        // break;
        case "trophy":
          this.onReceiveTrophy(data);
          break;
        case "removeStudent":
          this.onReceiveRemoveStudent(data);
          break;
        case "getUserStatus":
          this.onReceiveGetUserStatus(data);
          break;
        case "getInitUserStatus":
          this.onReceiveGetUserStatus(data);
          break;
        case "downstage":
          this.onReciveDownstage(data);
          break;
        case "upStagePermission":
          this.onReceiveUpStagePermission(data);
          break;
      }
    },
    handleCoursewareVideoVolumeChanged(data = {}) {
      if (this.roomInfo.isStudent) {
        return;
      }
      const state = this.getCoursewareVideoVolumeState(data);
      if (!state) {
        return;
      }
      this.coursewareVideoVolumeState = state;
      clearTimeout(this.coursewareVideoVolumeTimer);
      this.coursewareVideoVolumeTimer = setTimeout(() => {
        this.syncCurrentCoursewareVideoVolume("teacher_change");
      }, 150);
    },
    getCoursewareVideoVolumeState(data = {}) {
      const payload = data.data || data;
      if (payload.lessonId && payload.lessonId !== this.lessonId) {
        return null;
      }
      if (!payload.fileId) {
        return null;
      }
      return {
        fileId: payload.fileId,
        volume: payload.volume,
        muted: payload.muted,
        lessonId: payload.lessonId || this.lessonId,
      };
    },
    getCoursewareVideoVolumeMessage(state = this.coursewareVideoVolumeState) {
      if (!state?.fileId) {
        return null;
      }
      return {
        cmdId: 2,
        data: {
          type: "coursewareVideoVolume",
          data: {
            fileId: state.fileId,
            volume: state.volume,
            muted: state.muted,
            lessonId: this.lessonId,
          },
        },
      };
    },
    syncCurrentCoursewareVideoVolume(reason = "manual") {
      const message = this.getCoursewareVideoVolumeMessage();
      if (!this.imService || !message) {
        return;
      }
      uploadLiveLog({
        message: "老师端发送课件音量同步消息",
        tag: "courseware",
        extra: {
          component: "Index",
          action: "courseware_video_volume_send",
          reason,
          message,
        },
      });
      this.imService
        .sendMGLiveRoomCustomMsg(message)
        .then((res) => {
          uploadLiveLog({
            message: "老师端课件音量同步消息发送成功",
            tag: "courseware",
            extra: {
              component: "Index",
              action: "courseware_video_volume_send_success",
              reason,
              message,
              res,
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: "老师端课件音量同步消息发送失败",
            tag: "courseware",
            extra: {
              component: "Index",
              action: "courseware_video_volume_send_failed",
              reason,
              message,
              error: error?.message || String(error),
            },
          });
        });
    },
    applyCoursewareVideoVolumeState(reason = "receive", fromUserId) {
      if (!this.coursewareVideoVolumeState?.fileId) {
        return false;
      }
      const applied = this.whiteBoardService?.setVideoVolume(
        this.coursewareVideoVolumeState
      );
      uploadLiveLog({
        message: "同步课件视频音量",
        tag: "courseware",
        extra: {
          component: "Index",
          action: "courseware_video_volume",
          reason,
          fromUserId,
          applied,
          data: this.coursewareVideoVolumeState,
        },
      });
      return applied;
    },
    onReceiveCoursewareVideoVolume(data = {}, fromUserId) {
      const state = this.getCoursewareVideoVolumeState(data);
      if (!state) {
        return;
      }
      this.coursewareVideoVolumeState = state;
      if (fromUserId === this.userInfo.user_id) {
        return;
      }
      this.applyCoursewareVideoVolumeState("receive", fromUserId);
    },
    onReciveDownstage(data = {}) {
      const { userId, isDown } = data.data || {};
      const isSelf = userId === this.userStatus.user_id || userId === "*";
      console.log("onReciveDownstage___", isSelf, isDown, this.roomInfo);
      if (isSelf && !isDown) {
        clearTimeout(this.coursewareVideoVolumeApplyTimer);
        this.coursewareVideoVolumeApplyTimer = setTimeout(() => {
          this.applyCoursewareVideoVolumeState("self_upstage");
        }, 300);
      }
      if (
        isSelf &&
        !isDown &&
        this.roomInfo.room_type === 1 &&
        this.roomInfo.is_quick_live === 1 &&
        this.roomInfo.isStudent
      ) {
        // 大班课，快直播，自己是学生，上台, 默认右侧布局
        this.setLayout("vertical"); // 默认右侧布局
      }
    },
    // 收到上台权限
    onReceiveUpStagePermission(data) {
      const { isWhiteboard, isSendAudio, isSendVideo } = data.data || {};
      this.setRoomInfo({
        up_stage_whiteboard: isWhiteboard,
        up_stage_audio: isSendAudio,
        up_stage_video: isSendVideo,
      });
    },
    // 收到获取用户状态
    onReceiveGetUserStatus(data) {
      console.log("onReceiveGetUserStatus___", data);
      const { userId } = data.data || {};
      const isSelf = userId === this.userStatus.user_id || userId === "*";
      if (isSelf) {
        // 广播自己的状态
        this.initBroadcast();
      }
    },
    onReceiveRemoveStudent(data) {
      console.log("onReceiveRemoveStudent___", data);
      const { userId } = data.data || {};
      if (this.userStatus.user_id === userId) {
        this.$refs.kickedDialog.open();
        this.liveService?.exitRoom();
      }
    },
    // 收到奖杯
    onReceiveTrophy(data) {
      this.setShowTrophy({
        visible: false,
        info: {},
      });
      this.$nextTick(() => {
        this.setShowTrophy({
          visible: true,
          info: data.data || {},
        });
      });
    },
    // 收到学习模式改变
    onReceiveLearnModeChange(data) {
      const { lockScreenMode, focusMode } = data.data || {};
      if (lockScreenMode === true) {
        this.setRoomInfo({
          lock_screen_mode_state: 1,
        });
      } else if (lockScreenMode === false) {
        this.setRoomInfo({
          lock_screen_mode_state: 2,
        });
      }
      if (focusMode === true) {
        this.setRoomInfo({
          focus_mode_state: 1,
        });
      } else if (focusMode === false) {
        this.setRoomInfo({
          focus_mode_state: 2,
        });
      }
    },
    // 收到布局改变
    onReceiveLayoutChange(data) {
      // const { value } = data.data || {};
      // console.log("onReceiveLayoutChange", value);
      // this.setRoomInfo({
      //   live_layout: +value,
      // });
      // // 如果在台上，并且value是演讲者模式，不变，否则根据value设置布局
      // if (!(this.userStatus.is_up_stage === 1 && +value === 3)) {
      //   this.setLayout(LAYOUT_MAP[+value]);
      // }
    },
    // 收到更新白板类型
    onReceiveUpdateWhiteboardType(data) {
      const info = data.data || {};
      if (info.type) {
        this.setWhiteboardType(info.type);
      }
    },
    // 收到更新课件
    onReceiveUpdateCourseware() {
      this.getRoomInfo();
    },
    onReciveCourseInfo(data) {
      const { enrollment_count } = data?.data;
      this.setRoomInfo({
        enrollment_count: enrollment_count,
      });
    },
    // 结束直播
    onReciveEndLive() {
      this.liveService.exitRoom();
      this.$refs.liveEndDialog.open();
      this.closeNewChatPopup();
      clearInterval(this.keepAliveTimer);
      void playMediaSafely(this.$endClassBell);
    },
    onReciveXHRemoteEnterRoom(data) {
      // 有人加入房间
      console.log("new_live_djj___data>>>>>", data);
      if (this.imService && this.liveService.isEnterRoomSuccess) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "userInfo",
            data: {
              userId: this.userInfo.user_id,
              avatar: this.userInfo.avatar,
              nickname: this.userStatus.nickname,
            },
          },
        });
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "userStatus",
            data: this.userStatus,
          },
        });
        if (this.isScreenShare) {
          this.broadcastScreenShareStatus();
        }
        if (this.roomInfo.isTeacher) {
          this.syncCurrentCoursewareVideoVolume("remote_enter_room");
        }
      }
      const { userId } = data.data || {};
      if (userId && userId === this.userInfo.user_id) {
        // 被踢了
        this.$refs.multiLogin.open();
        this.imService?.logout();
        this.liveService.exitRoom();
        this.closeNewChatPopup();
        if (this.isScreenShare) {
          this.onLocalScreenShareStop();
        }
        clearInterval(this.keepAliveTimer);
      }
    },
    // 当收到远程屏幕共享消息
    onReciveScreenShare(data) {
      console.log("___data", data.data);
      const { from, status, isWhiteboard } = data.data;
      if (from === "desktop") {
        // 如果来自pc客户端, 需要加入一个
        if (this.whiteBoardService && isWhiteboard && status === "start") {
          // 检查并加入白板组的逻辑
          // this.checkAndJoinWhiteboardGroup();
        }
      }
      this.setRemoteScreenShareInfo({
        from,
        status,
        isWhiteboard,
      });
    },

    // 收到成员信息
    onReceiveUpdateNickname(data) {
      // const info = data.data;
      // if (info.userId === this.userStatus?.user_id) {
      //   // console.log("updateNickname-userStatus",this.userStatus.serverTime,info.nickname);
      //   if (
      //     !this.userStatus.serverTime ||
      //     this.userStatus.serverTime < info.serverTime
      //   ) {
      //     this.setUserStatus({
      //       nickname: info.nickname,
      //       serverTime: info.serverTime,
      //     });
      //   }
      // }
      // let allMemberStatus = this.allMemberStatus;
      // const tempIndex = allMemberStatus.findIndex(
      //   (item) => item.user_id === info.userId
      // );
      // console.log("tempIndex", tempIndex);
      // if (tempIndex >= 0) {
      //   const member = allMemberStatus[tempIndex];
      //   console.log("updateNickname-member", member.serverTime, info.nickname);
      //   if (!member.serverTime || member.serverTime < info.serverTime) {
      //     allMemberStatus[tempIndex] = Object.assign(
      //       allMemberStatus[tempIndex],
      //       {
      //         name: info.nickname,
      //         nickname: info.nickname,
      //         serverTime: info.serverTime,
      //       }
      //     );
      //     this.setAllMemberStatus(allMemberStatus);
      //     // this.setAllMemberStatusMap({
      //     //   user_id: info.userId,
      //     //   name: info.nickname,
      //     //   nickname: info.nickname,
      //     // });
      //   }
      // }
    },
    // 设备检测页面点击进入房间
    onEnterRoom(config) {
      if (this.isImReady) {
        console.log("进入房间", config);
        this.setShowDeviceCheck({
          visible: false,
          type: "init",
        });
        const isUpStage = this.userStatus.is_up_stage === 1;
        this.setUserStatus({
          audio_state: config.micro === "disabled" || !isUpStage ? 2 : 1,
          video_state: config.camera === "disabled" || !isUpStage ? 2 : 1,
        });
        this.handleEnterRoom();
      } else {
        this.$message.error("房间还未初始化，请稍后重试");
      }
    },
    handleEnterRoom() {
      this.liveService.enterRoom();
    },

    // 设置默认布局
    setDefaultLayout() {
      if (
        this.roomType === 1 ||
        (this.roomType === 2 && this.goodsRoomType === 1)
      ) {
        // 大班课或者小班课1v1   默认演讲者模式
        this.setLayout("speaker");
      } else {
        this.setLayout("horizontal");
      }
    },
    // 广播屏幕共享状态
    broadcastScreenShareStatus() {
      if (this.imService) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "screenShare",
            data: {
              status: this.screenShareStatus, // start 开始共享， pause 暂停共享 end 结束共享
              from: this.isElectron ? "desktop" : "web", // web网页端 desktop 桌面端
              isWhiteboard: this.isElectron
                ? this.screenSharePreInfo.isWhiteboard
                : false,
            },
          },
        });
      } else {
        console.error("共享屏幕状态变化-imService 不存在");
      }
    },
    handleResizeBarWidthChange(width) {
      if (this.resizeBarWidthDebounceTimer) {
        clearTimeout(this.resizeBarWidthDebounceTimer);
      }
      this.resizeBarWidthDebounceTimer = setTimeout(() => {
        console.log("宽度变化结束了", width);
        if (this.whiteBoardService) {
          this.whiteBoardService.resizeBoard();
        }
        this.resizeBarWidthDebounceTimer = null;
      }, 300);
    },
    onShowChatChange(val, oldVal) {
      if (this.whiteBoardService) {
        this.whiteBoardService.resizeBoard();
      }
    },
    // 处理屏幕共享白板问题
    dealScreenShareWhiteBoard() {
      if (!this.roomInfo.isTeacher) {
        return;
      }
      const lastScreenShareBoardIdObj = JSON.parse(
        localStorage.getItem("lastScreenShareBoardId") || "{}"
      );
      const { roomId, boardId } = lastScreenShareBoardIdObj;
      if (roomId === this.roomInfo.id && boardId) {
        this.whiteBoardService.deleteBoard(boardId);
      }
    },
    handleCloseUploadCourseware() {
      this.setShowUploadCourseware(false);
    },
    handleConfirmSelectCourseware(data) {
      const list = this.roomInfo.doc || [];
      if (list.some((item) => item.id === data.id)) {
        this.$darkMessage.error("课件已存在");
        return;
      }
      const unavailableReason = getCoursewareUnavailableReason(data);
      if (unavailableReason) {
        this.$darkMessage.error(unavailableReason);
        return;
      }
      if (data && data.id) {
        addFileToRoom({
          room_id: this.roomInfo.id,
          doc_id: [data.id],
        }).then((res) => {
          if (res.code === 1) {
            this.$darkMessage.success("添加成功");
            this.setShowUploadCourseware(false);
            this.handleInsertCourseware(data);
          } else {
            this.$darkMessage.error(res.message);
          }
        });
      }
    },
    handleInsertCourseware(data) {
      const list = this.roomInfo.doc || [];
      let beforeFileId = null;
      try {
        beforeFileId = this.whiteBoardService?.getCurrentFile?.();
      } catch (error) {
        console.warn("courseware_get_before_file_failed", error);
      }
      const uploadCoursewareDiagnosticLog = (message, extra = {}, level = "info") => {
        try {
          uploadLiveLog({
            message,
            level,
            tag: "courseware",
            extra: {
              component: "Index",
              ...extra,
            },
          });
        } catch (error) {
          console.warn("courseware_diagnostic_log_failed", error);
        }
      };
      const getWhiteBoardFileSnapshot = (roomFileId) => {
        try {
          return {
            currentFileId: this.whiteBoardService?.getCurrentFile?.(),
            currentFileInfo: this.whiteBoardService?.getFileInfo?.(),
            targetFileInfo: roomFileId
              ? this.whiteBoardService?.getFileInfo?.(roomFileId)
              : null,
            whiteBoardFileInfoList: this.whiteBoardService?.getFileInfoList?.(),
          };
        } catch (error) {
          return {
            snapshotError: error?.message || String(error),
          };
        }
      };
      uploadCoursewareDiagnosticLog("诊断课件插入切换开始", {
        action: "courseware_insert_switch_start",
        beforeFileId,
        fileId: data?.id,
        fileName: data?.doc_name || data?.file_name,
        existingRoomFileId: data?.roomFileId,
        listRoomFileIds: list.map((item) => item.roomFileId).filter(Boolean),
        ...getWhiteBoardFileSnapshot(),
      });
      const { id: roomFileId, error } = addCoursewareToWhiteboard(
        this.whiteBoardService,
        data
      );
      [3000, 12000].forEach((delay) => {
        setTimeout(() => {
          uploadCoursewareDiagnosticLog("诊断课件插入后延迟查询", {
            action: "courseware_insert_delayed_query",
            delay,
            beforeFileId,
            roomFileId,
            fileId: data?.id,
            fileName: data?.doc_name || data?.file_name,
            transcodeResult: data?.transcode_result,
            ...getWhiteBoardFileSnapshot(roomFileId),
          });
        }, delay);
      });
      uploadCoursewareDiagnosticLog("诊断课件插入结果", {
        action: "courseware_insert_result",
        beforeFileId,
        roomFileId,
        error,
        ...getWhiteBoardFileSnapshot(roomFileId),
      });
      if (error) {
        this.$darkMessage.error(error);
        return;
      }
      try {
        const switchResult = this.whiteBoardService.switchFile(roomFileId);
        Promise.resolve(switchResult)
          .then((res) => {
            uploadCoursewareDiagnosticLog("诊断课件切换成功回调", {
              action: "courseware_switch_resolved",
              beforeFileId,
              roomFileId,
              result: res,
              ...getWhiteBoardFileSnapshot(roomFileId),
            });
          })
          .catch((switchError) => {
            uploadCoursewareDiagnosticLog(
              "诊断课件切换失败回调",
              {
                action: "courseware_switch_rejected",
                beforeFileId,
                roomFileId,
                error: switchError?.message || String(switchError),
              },
              "error"
            );
          });
      } catch (switchError) {
        uploadCoursewareDiagnosticLog(
          "诊断课件切换同步异常",
          {
            component: "Index",
            action: "courseware_switch_throw",
            beforeFileId,
            roomFileId,
            error: switchError?.message || String(switchError),
          },
          "error"
        );
      }
      [200, 500].forEach((delay) => {
        setTimeout(() => {
          uploadCoursewareDiagnosticLog("诊断课件切换后当前文件", {
            action: "courseware_switch_current_file",
            delay,
            beforeFileId,
            targetRoomFileId: roomFileId,
            ...getWhiteBoardFileSnapshot(roomFileId),
          });
        }, delay);
      });
      list.unshift({
        ...data,
        roomFileId,
      });
      this.setRoomInfo({
        doc: list,
      });
      this.handleUpdateCoursewareInfo();
    },
    handleUpdateCoursewareInfo() {
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "coursewareUpdate",
        },
      });
    },
    // 处理屏幕共享播放按钮状态更新
    handleUpdateShowPlayButton(value) {
      this.screenShareShowPlayButton = value;
    },
    // 处理屏幕共享播放按钮点击
    handleScreenSharePlayClick() {
      if (
        this.$refs.screenShareRef &&
        this.$refs.screenShareRef.handlePlayClick
      ) {
        this.$refs.screenShareRef.handlePlayClick();
      }
    },
    // 客户端关闭聊天独立窗口
    closeNewChatPopup() {
      if (window.isElectron && window.ipcRenderer) {
        window.ipcRenderer.send("chat-close-window");
        this.SET_CHAT_MODE("embed");
      }
    },
  },
};
</script>

<style scoped lang="scss">
$chat-cont-min-width: 380px; // 聊天框最小宽度
$chat-cont-max-width: 658px; // 聊天框最大宽度
.page-wrap {
  width: 100vw;
}
// 分栏布局实现
.column.live-page-cont-wrap {
  overflow: hidden;
  .column-left {
    position: relative;
    float: left;
    transition: width 0.2s;
    &.column-left--full {
      width: 100% !important;
      float: none;
    }
  }

  .column-right {
    // padding: 16px;
    // background-color: #eee;
    box-sizing: border-box;
    overflow: hidden;
  }
  .column-left,
  .column-right,
  .right-content,
  .left-live-cont-wrap,
  .right-content > div {
    height: calc(100vh - $live-room-header-height);
    overflow: hidden;
  }

  // 学生下台使用CDN流时，全屏显示
  &.page-wrap__cdn {
    .column-left {
      height: 100vh !important;
    }
    .left-live-cont-wrap {
      height: 100vh !important;
    }
    .resize-line,
    .resize-bar {
      display: none !important;
    }
  }

  // 分栏聊天框头部样式（公共）
  .chat-page ::v-deep {
    .chat-header {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px 6px 12px;
      border-bottom: 1px solid #27272a;
      .operate-btns {
        display: flex;
        align-items: center;
        button {
          margin-left: 8px;
        }
      }

      .chat-title {
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
      }

      .close-btn,
      .modes-btn img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .resize-save {
    position: absolute;
    top: 0;
    right: 5px;
    bottom: 0;
    left: 0;
    // padding: 16px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
  .resize-save__record {
    right: 0px !important;
  }

  .resize-bar {
    width: calc(100vw - $chat-cont-min-width);
    max-width: calc(100vw - $chat-cont-min-width);
    min-width: calc(100vw - $chat-cont-max-width);
    height: inherit;
    resize: horizontal;
    cursor: ew-resize;
    cursor: col-resize;
    opacity: 0;
    overflow: scroll;
  }

  /* 拖拽线 */
  .resize-line {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 1px solid #000000;
    border-left: 1px solid #000000;
    pointer-events: none;
  }

  .resize-bar:hover ~ .resize-line,
  .resize-bar:active ~ .resize-line {
    border-left: 1px solid #165dff;
  }

  .resize-bar::-webkit-scrollbar {
    width: 200px;
    height: inherit;
  }

  /* Firefox只有下面一小块区域可以拉伸 */
  @supports (-moz-user-select: none) {
    .resize-bar:hover ~ .resize-line,
    .resize-bar:active ~ .resize-line {
      border-left: 1px solid #bbb;
    }

    .resize-bar:hover ~ .resize-line::after,
    .resize-bar:active ~ .resize-line::after {
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      bottom: 0;
      right: -8px;
      // background: url(./resize.svg);
      background-size: 100% 100%;
    }
  }
}

::v-deep .live-room-el-select {
  .el-input__inner {
    border-radius: 12px !important;
  }
}

.page-wrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #18181b;
  justify-content: space-between;
  position: relative;
  max-height: 100vh;
  overflow: hidden;
  .layout-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    .courseware-list {
      position: absolute;
      bottom: 64px;
      right: 20px;
      z-index: 9;
    }
    &.layout-box__horizontal {
      display: flex;
      flex-direction: column;
      .white-board-wrap {
        height: 0;
      }
    }

    &.layout-box__vertical {
      display: flex;
      flex-direction: row;
      flex-flow: row-reverse;
      .white-board-wrap {
        width: 0;
      }
    }

    &.layout-box__speaker {
      display: flex;
      position: relative;
      .white-board-wrap {
        height: 0;
      }
    }

    &.layout-box__cdn {
      display: flex;
      flex-direction: column;
      position: relative;
      .person-list-box {
        display: none;
      }
      .white-board-wrap {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        .screen-share-box {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .white-board-box {
    background: #e5e6eb;
    overflow: hidden;
  }

  ::v-deep .white-board-box .video-js .vjs-tech {
    object-fit: cover;
  }

  .white-board-wrap {
    position: relative;
    flex: 1;
    display: flex;

    .screen-share-box {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
    }
    .screen-share-play-button-overlay {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1001;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      cursor: pointer;

      .screen-share-play-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 14px 32px;
        background: rgba(0, 0, 0, 0.6);
        border: 2px solid rgba(255, 255, 255, 0.8);
        border-radius: 50px;
        transition: all 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.8);
          border-color: rgba(255, 255, 255, 1);
          transform: scale(1.05);
        }

        .icon-bars {
          display: flex;
          align-items: flex-end;
          gap: 4px;
          margin-right: 12px;

          .bar {
            width: 4px;
            background: #ffffff;
            border-radius: 2px;

            &:nth-child(1) {
              height: 20px;
            }

            &:nth-child(2) {
              height: 24px;
            }

            &:nth-child(3) {
              height: 16px;
            }
          }
        }

        .screen-share-play-button-text {
          font-size: 16px;
          color: #ffffff;
          font-weight: 500;
          white-space: nowrap;
        }
      }
    }
    .copyright {
      position: absolute !important;
      width: 100%;
      height: 28px;
      top: 0;
      left: 0;
      z-index: 970;
    }
    .org-name-watermark {
      position: absolute;
      font-size: 16px;
      left: 20px;
      top: 38px;
      color: rgba(0, 0, 0, 0.5); /* 白色填充（亮底可见） */
      z-index: 1000;
    }
  }
}

.page-wrap__electron {
  height: 100%;
}

.page-wrap__web__share {
  // 网页端本地共享样式
  .white-board-wrap {
    position: relative;
    flex: 1;
    display: flex;
  }
}

.page-wrap__electron__share ::v-deep {
  // 客户端本地共享样式
  background: unset !important;
  .live-page-cont-wrap {
    .resize-right-chat-wrap {
      opacity: 0;
    }
  }
  .resize-line {
    opacity: 0 !important;
  }
  .bar-btn {
    opacity: 0 !important;
  }
  .person-list-box {
    // position: fixed;
    // right: 0;
    // top: 100px;
  }
  .white-board-box {
    background: unset !important;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
  }
  .bottom-controller-wrap {
    opacity: 0 !important;
    z-index: 9;
  }
  .tx_board_canvas_wrap {
    background: unset !important;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    .tx_board_canvas_box {
      opacity: 0 !important;
    }
  }
  .whiteboard-toolbar {
    z-index: 1000;
  }
}
.page-wrap__share__remote ::v-deep {
  // 接收共享端
  .white_board_box_screen_remote {
    z-index: 960;
    background: unset !important;
    .tx_board_canvas_wrap {
      background: unset !important;
      position: fixed;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 960;
      .tx_board_canvas_box {
        opacity: 0 !important;
      }
    }
  }
}
.page-wrap__record {
  .column-left {
    height: calc(100vh - 0px) !important;
  }
  .left-live-cont-wrap {
    height: 100% !important;
  }
}
.loading-box {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .mask {
    width: 100%;
    height: 100%;
    backdrop-filter: blur(7px);
    /* 设置高斯模糊效果 */
    background-color: rgba(0, 0, 0, 0.2);
    /* 背景颜色 */
  }

  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 16px;
  }
}

.disabled-capture-mask {
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  backdrop-filter: blur(7px);
  /* 设置高斯模糊效果 */
  background: #18181b;
  font-size: 14px;

  .tips {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 50px;
    width: 225px;
    height: 40px;
    background: #27272a;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ecedee;
  }

  p {
    line-height: 30px;
  }

  .btn {
    margin-top: 16px;
    width: 144px;
    height: 40px;
    background: #0e42d2;
    border-radius: 12px;
    font-weight: 400;
    font-size: 14px;
    color: #e8f3ff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
@import "./css/common.scss";
.disabled-capture_message {
  z-index: 999999999;
}
</style>
